const newCompany = {
	path: ':customerName?/:customerId?/companies/new',
	name: 'company-new',
	meta: {
		title: 'Nueva Empresa',
	},
	component: () => import('@/components/companies/company-form'),
	props: true,
};

export default newCompany;



// WEBPACK FOOTER //
// ./src/router/companies-new.js